var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 52 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.499654,-3.85186e-34,-1.15556e-33,0.499654,20.0041,6.00415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,8C7.3,8 8,8.7 8,9.5C8,10.3 7.3,11 6.5,11C5.7,11 5,10.3 5,9.5C5,8.7 5.7,8 6.5,8M6.5,7C5.1,7 4,8.1 4,9.5C4,10.9 5.1,12 6.5,12C7.9,12 9,10.9 9,9.5C9,8.1 7.9,7 6.5,7ZM22,3L2,3C0.9,3 0,3.9 0,5L0,19C0,20.1 0.9,21 2,21L22,21C23.1,21 24,20.1 24,19L24,5C24,3.9 23.1,3 22,3ZM2,5L22,5L22,14.6L17.9,10.5C16.6,9.2 14.4,9.2 13,10.5L9,14.5C8,14.1 6.8,14.3 6,15.1L2.1,19L2,19L2,5ZM7.4,16.5C7.5,16.4 7.5,16.4 7.6,16.4C7.9,16.2 8.3,16.3 8.6,16.5L11.1,19L4.9,19L7.4,16.5ZM14,19L10.7,15.7L14.5,11.9C15.1,11.3 16,11.3 16.6,11.9L22.1,17.4L22.1,19L14,19Z",
    style: {
      fill: "rgb(211,219,226)",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.e363055560a6fd1dab2e8c0747928aed.svg";
export { ForwardRef as ReactComponent };